export default "__VITE_ASSET__BF7b5J4r__"